<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		class?: string;
		children?: Snippet;
	}

	let { class: className = '', children }: Props = $props();
</script>

<!-- Brand-gradient feature panel with a tinted shadow. Always white text.
     Layout (padding, grid) is supplied by the caller via `class`. -->
<div class="bg-brand-gradient rounded-3xl text-white shadow-2xl shadow-primary-500/20 {className}">
	{@render children?.()}
</div>
